import {
  Check,
  TimerOutlined,
  NotInterested,
  HourglassEmpty,
  ErrorOutlineOutlined,
  HistoryToggleOffOutlined,
} from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import {
  EHR_CHIP_TOOLTIP_TEXT_MAP,
  EHR_STATUS_COLOR_MAP,
  EHR_STATUS_TEXT_MAP,
} from "static/constants";

const EHRStatus = ({ status }) => {
  const currentStatus = status || "not_initiated";
  const hexColor = EHR_STATUS_COLOR_MAP[currentStatus];

  const renderIcon = {
    completed: <Check style={{ color: "#94BA33" }} fontSize="small" />,
    pending: <TimerOutlined style={{ color: "#FF9800" }} fontSize="small" />,
    error: (
      <ErrorOutlineOutlined style={{ color: "#f44336" }} fontSize="small" />
    ),
    timeout: (
      <HistoryToggleOffOutlined style={{ color: "#9E9E9E" }} fontSize="small" />
    ),
    not_initiated: (
      <HourglassEmpty style={{ color: "#175EC8" }} fontSize="small" />
    ),
    not_applicable: (
      <NotInterested style={{ color: "#9E9E9E" }} fontSize="small" />
    ),
  };

  return (
    <Tooltip title={EHR_CHIP_TOOLTIP_TEXT_MAP[currentStatus]}>
      <Chip
        variant="outlined"
        icon={renderIcon[currentStatus]}
        style={{
          borderColor: hexColor,
          color: hexColor,
        }}
        label={EHR_STATUS_TEXT_MAP[currentStatus]}
      />
    </Tooltip>
  );
};

EHRStatus.propTypes = {
  status: PropTypes.string,
};

export default EHRStatus;
